var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.878 0C32.56 0 35.14 1.06 37.038 2.962C38.938 4.86 40 7.42 40 10.1V25.9C40 31.48 35.46 36 29.878 36H10.12C4.538 36 0 31.48 0 25.9V10.1C0 4.52 4.518 0 10.12 0H29.878ZM32.14 10.4C31.72 10.378 31.32 10.52 31.018 10.8L22 18C20.84 18.962 19.178 18.962 18 18L9 10.8C8.378 10.34 7.518 10.4 7 10.94C6.46 11.48 6.4 12.34 6.858 12.94L7.12 13.2L16.22 20.3C17.34 21.18 18.698 21.66 20.12 21.66C21.538 21.66 22.92 21.18 24.038 20.3L33.06 13.08L33.22 12.92C33.698 12.34 33.698 11.5 33.198 10.92C32.92 10.622 32.538 10.44 32.14 10.4Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email_icon.8993c727.svg";
export { ForwardRef as ReactComponent };